import { IonBadge, IonButton, IonCol, IonIcon } from "@ionic/react";
import "./CartProduct.scss";
import { CartItem } from "../../types/shop/cart.type";
import { preventOverflow } from "../../functions/string.functions";
import { trash } from "ionicons/icons";
import shoppingCartService from "../../services/shop/cart.service";
import { useAppContext, useAppContextUpdater } from "../../services/app-context.service";
import CartProductEdit from "./CartProductEdit";
import { Link } from "react-router-dom";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getPriceFactor, getProductImageUrl, getProductUrl } from "../../functions/product.functions";
import ProgressiveImg from "../ProgressiveImg";

type Props = {
    itemIndex: number
    cartItem: CartItem
}
const BDT = new Intl.NumberFormat('en-IN');
const CartProduct: React.FC<Props> = ({ itemIndex, cartItem }) => {
    const data = useAppContext()
    const SetData = useAppContextUpdater()
    const priceFactor = getPriceFactor(data.settings)
    function onUpdateCart() {
        data.cart = shoppingCartService.shoppingCart
        SetData({ ...data })
    }
    function onDelete(itemIndex: number) {
        shoppingCartService.removeItemFromCart(itemIndex,priceFactor)
        onUpdateCart()
    }
    return (

        <IonCol size="12">
            <div className='cart-product'>
                <Link to={getProductUrl(cartItem.item_id)} className='cover-img' >
                    <ProgressiveImg src={getProductImageUrl(cartItem.imageUrl, 80)} alt={cartItem.title} />
                </Link>

                <CartProductEdit className='info' itemIndex={itemIndex} cartItem={cartItem}>
                    <h6>{preventOverflow(cartItem.title, 33)}</h6>
                    <div className="attribute">
                        <p>{cartItem.selectedSku.props_names}</p>
                    </div>
                    <div className="qty-price">
                        <FontAwesomeIcon icon={faEdit} />
                        <p>{cartItem.quantity} X ৳ {BDT.format(cartItem.unitPrice)}</p>
                    </div>
                </CartProductEdit>
                <div className='price'>
                    <IonBadge color="primary">৳ {BDT.format(cartItem.itemTotal)}</IonBadge>
                    <IonButton fill="clear" onClick={() => onDelete(itemIndex)}><IonIcon icon={trash} /></IonButton>
                </div>
            </div>
        </IonCol>
    );
}
export default CartProduct
